import { isNull, isUndefined, omitBy, pick } from 'lodash';

export const objToUrlParams = (obj = {}) => {
    const filteredArgs = omitBy(obj, v => isUndefined(v) || isNull(v));
    const params = new URLSearchParams(filteredArgs).toString();

    return params ? '?' + params : '';
};

/*
  The paging a list asks the server for. The pagination a list holds also has what the footer needs (hasNextPage), which is not
  a parameter of the request.
*/
export const pagingParams = pagination =>
    pick(pagination, ['page', 'pageSize']);
